/**
 * FindAccountPresenter
 * --
 */
import React from 'react';
import { Content, Row, Col, Title, Tabs } from 'components';
import { Input, Button } from 'antd';
import Formatter from 'utils/Formatter';

const tabItems = [
  {
    key: 'phone',
    label: '휴대폰 인증',
  },
  {
    key: 'email',
    label: '이메일 인증',
  },
];

const FindAccountPresenter = ({
  nameRef,
  authRef,
  authCodeRef,
  inputValue,
  tabKey,
  message,
  status,
  timeText,
  authCode,
  onTabChange,
  onChange,
  onSend,
  onSubmit,
  screenSize,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 40 : 32,
      lineHeight: '120%',
      fontWeight: 700,
      color: 'var(--black-color)',
    },

    tabStyle: {
      width: '50%',
      textAlign: 'center',
      fontSize: 18,
      fontWeight: 700,
      padding: 0,
      margin: 0,
    },

    input: {
      width: '100%',
      height: 44,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '180%',
    },

    button: {
      height: 44,
      fontSize: 16,
      fontWeight: 700,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    message: {
      fontSize: 12,
      fontWeight: 400,
      color: 'var(--danger-color)',
      display: status === 'default' ? 'none' : 'inline-block',
      marginTop: 4,
    },
  };

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={1820} padding={'100px 0px'}>
      <Row gutter={16}>
        <Col x={1} md={8}></Col>
        <Col x={22} md={8}>
          <Title align={'center'} style={{ ...styles.title }}>
            아이디 찾기
          </Title>

          <Tabs
            items={tabItems}
            style={{
              ...styles.tabStyle,
            }}
            layoutStyle={{ marginTop: screenSize >= 768 ? 80 : 30 }}
            activeKey={tabKey}
            activeColor={'var(--black-color)'}
            onChange={(k) => onTabChange(k)}
          />

          {/* 입력 폼 */}
          <Row
            gutter={16}
            style={{ marginTop: screenSize >= 768 ? 80 : 30, marginBottom: 20 }}
          >
            <Col x={16}>
              <Input
                ref={nameRef}
                value={inputValue.name}
                style={{ ...styles.input }}
                placeholder="이름을 입력해 주세요."
                onChange={(e) => onChange('name', e.target.value)}
                disabled={authCode}
              />
            </Col>
            <Col x={8}></Col>
          </Row>
          <Row gutter={16}>
            <Col x={16}>
              <Input
                ref={authRef}
                value={inputValue.auth}
                style={{ ...styles.input }}
                placeholder={`${
                  tabKey === 'phone'
                    ? `휴대폰 번호를 '-'을 포함하여`
                    : '이메일을'
                } 입력해 주세요.`}
                onChange={(e) =>
                  onChange(
                    'auth',
                    tabKey === 'phone'
                      ? Formatter.hyphen(e.target.value)
                      : e.target.value
                  )
                }
                disabled={authCode}
              />
            </Col>
            <Col x={8}>
              <Button
                type={authCode ? 'default' : 'primary'}
                style={{ ...styles.button }}
                onClick={() => onSend()}
              >
                인증번호
              </Button>
            </Col>
          </Row>

          {authCode && (
            <Row gutter={16} style={{ marginTop: 20 }}>
              <Col x={16}>
                <Input
                  ref={authCodeRef}
                  value={inputValue.authCode}
                  style={{ ...styles.input }}
                  maxLength={6}
                  placeholder={`인증번호 6자리를 입력해 주세요.`}
                  onChange={(e) => onChange('authCode', e.target.value)}
                  suffix={
                    <p
                      style={{
                        color: 'var(--danger-color)',
                      }}
                    >
                      {timeText}
                    </p>
                  }
                />
              </Col>
              <Col x={8}>
                <Button
                  type="primary"
                  style={{ ...styles.button }}
                  onClick={() => onSubmit()}
                >
                  확인
                </Button>
              </Col>
            </Row>
          )}

          <p
            style={{
              ...styles.message,
            }}
          >
            {message}
          </p>
          {/* 입력 폼 끝 */}
        </Col>
        <Col x={1} md={8}></Col>
      </Row>
    </Content>
  );
};

export default FindAccountPresenter;
